import { createFileRoute } from "@tanstack/react-router";
import { ServiceReviewPage } from "@/components/site/ServiceReviewPage";
import { serviceReviewHead } from "@/lib/serviceReviewHead";
export const Route = createFileRoute("/services/partner-alignment")({
  head: () => serviceReviewHead("partner-alignment"),
  component: () => <ServiceReviewPage slug="partner-alignment" />,
});
